import MasterModal from 'components/organisms/masterModal';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import SearchIcon from 'components/atoms/icons/search.svg?react';

import s from './styles.module.scss';

interface SummaryModalProps {
  open: boolean;
  subTitle: string;
  summary?: string;
  loading: boolean;
  onCancel: () => void;
}

const SummaryModal: FC<SummaryModalProps> = ({
  open,
  onCancel,
  summary = '',
  loading,
  subTitle,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <MasterModal
      title={t('patientSnapshot.summary')}
      subTitle={subTitle}
      isOpen={open}
      toggle={onCancel}
      footer={false}
      size="medium"
      modalClassName={s['modal-container']}
    >
      {!summary && !loading ? (
        <div className={s['empty-data-wrapper']}>
          <EmptyTablePlaceholder
            text={t('patientSnapshot.noDataFound')}
            icon={<SearchIcon width={70} height={70} />}
            column
          />
        </div>
      ) : (
        <BaseSpinWrapper spinning={loading}>
          <p className={s.summary}>{summary}</p>
        </BaseSpinWrapper>
      )}
    </MasterModal>
  );
};
export default SummaryModal;
